import { IIdentifiable } from '@/common/models/models'
import { IVoiceBankType, VoiceBankType } from '@/common/models/data/dashboard/voice-bank/voice-bank-type'
import { IVoiceBankLanguage, VoiceBankLanguage } from '@/common/models/data/dashboard/voice-bank/voice-bank-language'

interface IVoiceBankEntry extends IIdentifiable {
    name: string
    female: boolean
    type_id: number
    lang_id: number
    file: string
    download_url: string

    type: IVoiceBankType
    language: IVoiceBankLanguage
}

class VoiceBankEntry implements IVoiceBankEntry {
    id = 0
    name = ''
    female = false
    type_id = 0
    lang_id = 0
    file = ''
    download_url = ''

    type = new VoiceBankType()
    language = new VoiceBankLanguage()

    audioFile: File | null = null

    constructor (dto?: IVoiceBankEntry) {
        if (dto) {
            this.id = dto.id
            this.name = dto.name
            this.female = dto.female
            this.type_id = dto.type_id
            this.lang_id = dto.lang_id
            this.file = dto.file
            this.download_url = dto.download_url

            this.type = new VoiceBankType(dto.type)
            this.language = new VoiceBankLanguage(dto.language)
        }
    }
}

export {
    IVoiceBankEntry, VoiceBankEntry
}
